import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { NumberMaterialInput } from 'components/Custom/NumberMaterialInput'

export interface CurrencyInputControllerProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  error?: boolean
  helperText?: string
  disabled?: boolean
  min?: number
  max?: number
  maxLength?: number // Adicionando maxLength como prop
  disableConvertMaxOnBlur?: boolean
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
}

export const CurrencyInputController = <T extends FieldValues>({
  control,
  name,
  label,
  error,
  helperText,
  disabled,
  min = 0,
  max = 999999999999.99,
  disableConvertMaxOnBlur = false,
  maxLength, // Prop para limitar o número de caracteres
  onBlur
}: CurrencyInputControllerProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <NumberMaterialInput
          {...field}
          disableConvertMaxOnBlur={disableConvertMaxOnBlur}
          label={label}
          value={field.value}
          disabled={disabled}
          error={error}
          helperText={helperText}
          adornment="R$"
          fullWidth
          max={max}
          min={min}
          maxLength={maxLength} // Passando o maxLength para o NumberMaterialInput
          onBlur={onBlur}
        />
      )}
    />
  )
}
